var createStylesheet = (chunkId, fullhref, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	(function(linkTag) {
	                if (typeof _N_E_STYLE_LOAD === 'function') {
	                    const { href, onload, onerror } = linkTag;
	                    _N_E_STYLE_LOAD(new URL(href).pathname).then(()=>onload == null ? void 0 : onload.call(linkTag, {
	                            type: 'load'
	                        }), ()=>onerror == null ? void 0 : onerror.call(linkTag, {}));
	                } else {
	                    document.head.appendChild(linkTag);
	                }
	            })(linkTag)
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	8068: 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"89":1,"159":1,"203":1,"263":1,"439":1,"527":1,"653":1,"739":1,"769":1,"911":1,"1231":1,"1269":1,"1283":1,"1287":1,"1315":1,"1351":1,"1647":1,"1870":1,"2049":1,"2087":1,"2159":1,"2223":1,"2425":1,"2503":1,"2527":1,"2567":1,"2595":1,"2607":1,"2625":1,"2721":1,"2879":1,"3282":1,"3287":1,"3311":1,"3339":1,"3387":1,"3401":1,"3565":1,"3575":1,"3810":1,"3839":1,"3871":1,"3911":1,"4022":1,"4023":1,"4083":1,"4095":1,"4175":1,"4191":1,"4282":1,"4283":1,"4495":1,"4527":1,"4599":1,"4619":1,"4731":1,"4768":1,"4795":1,"4800":1,"4867":1,"4947":1,"5013":1,"5059":1,"5067":1,"5251":1,"5253":1,"5315":1,"5317":1,"5375":1,"5413":1,"5455":1,"5579":1,"5647":1,"5671":1,"5693":1,"5911":1,"5975":1,"6111":1,"6247":1,"6251":1,"6270":1,"6543":1,"6572":1,"6751":1,"6919":1,"6923":1,"6947":1,"6951":1,"7155":1,"7291":1,"7295":1,"7331":1,"7367":1,"7369":1,"7523":1,"7533":1,"7551":1,"7733":1,"8055":1,"8185":1,"8285":1,"8671":1,"8783":1,"8900":1,"8963":1,"9071":1,"9117":1,"9208":1,"9359":1,"9403":1,"9627":1,"9647":1,"9713":1,"9883":1,"9931":1,"9943":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr